import { createSelector } from 'reselect';

import {
  selectEntitiesMissionsEntityDescription,
  selectEntitiesMissionsEntityImageUrl,
  selectEntitiesMissionsEntityLogoUrl,
  selectEntitiesMissionsEntityOperationType,
  selectEntitiesMissionsEntityOptInEnabled,
  selectEntitiesMissionsEntityShowTimer,
  selectEntitiesMissionsEntityTitle,
} from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import {
  selectUserConnected,
  selectUserMissionsModerator,
  selectUserPromotionStatus,
} from '../../../../selectors/user/userPrimary.selector';
import { PromotionStatus } from '../../../../types/promotions';
import { Selector } from '../../../../types/selectors';
import { selectUserMissionHasUserRegistered } from '../../selectors/userMissions';
import { MissionOperationType } from '../../types/state/missions';
import { selectUserMissionWonAmount } from '../MissionCard/MissionCard.selector';

type MissionDetailsPropsType = {
  title?: string;
  description?: string;
  logoURL?: string | null;
  backgroundURL?: string | null;
  wonAmount?: number;
  operationType?: MissionOperationType;
  showTimer: boolean;
  hasUserRegistered: boolean;
  optInRequired: boolean;
  isUserConnected: boolean;
  promotionStatus: PromotionStatus;
  missionsModerator: boolean;
};

const selectMissionDetailsContainerProps: Selector<MissionDetailsPropsType> = createSelector(
  [
    selectEntitiesMissionsEntityTitle,
    selectEntitiesMissionsEntityDescription,
    selectEntitiesMissionsEntityLogoUrl,
    selectEntitiesMissionsEntityImageUrl,
    selectUserMissionWonAmount,
    selectEntitiesMissionsEntityOperationType,
    selectEntitiesMissionsEntityShowTimer,
    selectUserMissionHasUserRegistered,
    selectEntitiesMissionsEntityOptInEnabled,
    selectUserConnected,
    selectUserPromotionStatus,
    selectUserMissionsModerator,
  ],
  (
    title,
    description,
    logoURL,
    backgroundURL,
    wonAmount,
    operationType,
    showTimer,
    hasUserRegistered,
    optInRequired,
    isUserConnected,
    promotionStatus,
    missionsModerator,
  ) => ({
    title,
    description,
    logoURL,
    backgroundURL,
    wonAmount,
    operationType,
    showTimer,
    hasUserRegistered,
    optInRequired,
    isUserConnected,
    promotionStatus,
    missionsModerator,
  }),
);

export default selectMissionDetailsContainerProps;
